import React from 'react';
import { Menu, Pause, Pencil, Play, Undo2, Video } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { formatClock } from './gameUtils';

const clockTone = (clock) => {
  if (clock.running) return 'text-emerald-300 border-emerald-400/60 bg-emerald-500/10 hover:bg-emerald-500/20';
  if ((clock.remaining_sec ?? 0) === 0) return 'text-amber-300 border-amber-400/60 bg-amber-500/10 hover:bg-amber-500/20';
  return 'text-white border-white/40 hover:bg-white/10';
};

export function ClockRow({ quarter, clock, onOpenMenu, onToggle, onEdit }) {
  return (
    <div className="flex items-center justify-center gap-3 py-2 border-t border-white/10 bg-[#0A0F2C]/70" data-testid="clock-row">
      <button onClick={onOpenMenu}
        className="text-amber-300 text-sm font-semibold underline-offset-4 hover:underline"
        data-testid="period-label">
        P{quarter}
      </button>
      <button onClick={onToggle}
        className={`inline-flex items-center gap-1.5 font-mono tabular-nums text-base sm:text-lg font-bold px-3 py-1 rounded-md border transition-colors ${clockTone(clock)}`}
        title={clock.running ? 'Pause clock' : 'Start clock'}
        data-testid="clock-toggle-btn">
        {clock.running ? <Pause className="w-3.5 h-3.5" /> : <Play className="w-3.5 h-3.5" />}
        <span data-testid="clock-display">{formatClock(clock.remaining_sec ?? clock.quarter_length_sec ?? 600)}</span>
      </button>
      <button onClick={onEdit} className="text-white/60 hover:text-white" aria-label="Edit clock" data-testid="clock-edit-btn">
        <Pencil className="w-4 h-4" />
      </button>
    </div>
  );
}

const dockBtn = 'w-10 h-10 rounded-full border border-white/30 text-white/80 hover:text-white hover:border-white flex items-center justify-center transition-colors';

export function BottomDock({ activeTeamName, onMenu, onUndo }) {
  return (
    <div className="border-t border-white/10 px-3 py-2 flex items-center justify-between bg-[#0A0F2C]/80">
      <button onClick={onMenu} aria-label="Menu" className={dockBtn} data-testid="menu-btn">
        <Menu className="w-4 h-4" />
      </button>
      <div className="text-[10px] text-white/40 tracking-widest uppercase">
        Active: <span className="text-amber-300">{activeTeamName}</span> · tap a stat to record
      </div>
      <button onClick={onUndo} aria-label="Undo last" className={dockBtn} data-testid="undo-btn">
        <Undo2 className="w-4 h-4" />
      </button>
    </div>
  );
}

export function VideoUrlBar({ value, onChange, onSave }) {
  return (
    <div className="bg-slate-800 px-4 py-2 flex items-center gap-2 border-b border-slate-700">
      <Video className="w-4 h-4 text-amber-400 shrink-0" />
      <input type="text" value={value} onChange={(e) => onChange(e.target.value)}
        placeholder="Paste video URL (YouTube, etc.)..."
        className="flex-1 bg-slate-700 text-white text-xs px-3 py-1.5 rounded border border-slate-600 focus:outline-none focus:border-amber-400"
        data-testid="video-url-input" />
      <Button size="sm" onClick={onSave} className="bg-amber-500 hover:bg-amber-600 text-black h-7 text-xs" data-testid="save-video-btn">
        Save
      </Button>
    </div>
  );
}
